<template>
  <div class="plan">
    <div v-if="showListSpeedUp" class="speedup-list">
      <SpeedUpChoose :planId="plan.id" @onClosed="onSpeedUpClosedHanlder()" />
    </div>
    <div class="plan-overview">
      <div class="id-overlay">{{plan.id}}</div>
      <TreeImage :percent="percentRest"/>
      <div class>Start time: {{formatTime(plan.startTime)}}</div>
      <div class>
        Bonus time: {{plan.bonusTime}} min
        <div
          v-if="showSpeedUp"
          class="button is-success is-small"
          @click="showListSpeedUp=!showListSpeedUp"
        >Speed up</div>
      </div>
      <div v-if="plan.harvestTime == 0">
        Time grownth complete: {{(minuteRestToHarvest)}} min
        <div
          v-if="showHarvestButton"
          class="button is-danger is-small"
          @click="harvest()"
        >Harvest now!</div>
      </div>
      <div v-else>Harvested time: {{formatTime(plan.harvestTime)}}</div>
    </div>
    <Factory
      class="plan-factory"
      :factory="factories[plan.factoryId]"
      :mulSeed="plan.mulSeed"
      hidePlant
    />
  </div>
</template>

<script>
import Factory from "@/components/Factory.vue";
import contract from "./../Utils/Contract";
import SpeedUpChoose from "@/components/SpeedUpChoose";
import TreeImage from "@/components/TreeImage.vue";

import { formatTime } from "@/Utils/Format";
import sleep from "./../Utils/Sleep";

export default {
  data() {
    return {
      minuteRestToHarvest: 0,
      showListSpeedUp: false
    };
  },
  computed: {
    timeToHarvest: function() {
      let startTime = new Date(this.plan.startTime * 1000);
      let timeToHarvest = new Date(this.plan.startTime * 1000);
      timeToHarvest.setMinutes(
        startTime.getMinutes() +
          this.factories[this.plan.factoryId].timeToGrown -
          this.plan.bonusTime
      );
      return timeToHarvest;
    },
    showHarvestButton: function() {
      return this.minuteRestToHarvest <= 0;
    },
    showSpeedUp: function() {
      return this.minuteRestToHarvest > 0;
    },
    factories: function() {
      return contract.factories;
    },
    elements: function() {
      return contract.elements;
    },
    percentRest:function(){
      return (1-this.minuteRestToHarvest/ this.factories[this.plan.factoryId].timeToGrown);
    }
  },
  components: {
    Factory,
    SpeedUpChoose,
    TreeImage
  },
  methods: {
    formatTime: function(val) {
      return formatTime(val);
    },
    harvest: async function() {
      await contract.harvest(this.plan.id);
      this.$toast.open({
        message: "Harvest success!",
        type: "is-success"
      });
      await sleep(3000);
      this.$emit("onChanged", this.plan.id);
    },
    onSpeedUpClosedHanlder: async function() {
      this.showListSpeedUp = false;
     await sleep(3000);

      this.$emit("onChanged", this.plan.id);
    }
  },
  created() {
    let self = this;
    let reCalTime = function() {
      self.minuteRestToHarvest = Math.round(
        (self.timeToHarvest - new Date(Date.now())) / (1000 * 60)
      );
    };
    reCalTime();
    setInterval(reCalTime, 60000);
  },
  props: {
    plan: {
      type: Object,
      default: function() {
        return {
          startTime: Date.now(),
          bonusTime: 0,
          harvestTime: 0,
          mulSeed: 1,
          factoryId: 0
        };
      }
    }
  }
};
</script>

<style>
.plan {
  padding: 10px;
  border-radius: 10px;
  position: relative;
  box-shadow: rgba(31, 42, 75, 0.2) 0px 20px 40px;
}
.plan-factory {
  box-shadow: 0px 5px 10px rgba(31, 42, 75, 0.2) inset;
  margin-top: 10px;
}
.plan-overview {
  position: relative;
}
.id-overlay {
  font-weight: bold;
  font-size: 100px;
  position: absolute;
  z-index: 0;
  opacity: 0.1;
  right: 0;
  top: -30px;
}
.speedup-list {
  margin: -10px;
  width: 100%;
  position: absolute;
  z-index: 999;
  background: #fff;
  height: 100%;
}
</style>